import Dict from '@/utils/dict-utils'

// 电子标书状态
export const kpbBidFileStatusDict = new Dict({
  PRE: { label: '预生成', value: -2 },
  INIT: { label: '草稿', value: 0 },
  SAVED: { label: '已保存', value: 1 },
  PUBLISHED: { label: '已锁定', value: 2 },
  LINKED: { label: '已关联', value: 3 }
})

// 线上开评标项目的项目状态数据字典
export const kpbProjectStatusDict = new Dict({
  SAVED: { label: '保存', value: 0 },
  PUBLISHED: { label: '已发布', value: 1 },
  OPEN_BID_STARTED: { label: '已开标', value: 2 },
  OPEN_MARK: { label: '进入唱标', value: 3 },
  OPEN_BID_ENDED: { label: '开标结束', value: 4 },
  EVALUATION_STARTED: { label: '评标开始', value: 5 },
  EVALUATION_SUMMARY: { label: '评标已汇总', value: 6 },
  EVALUATION_ENDED: { label: '评标结束', value: 7 }
})

// 评审模式
export const reviewModelDict = new Dict({
  DEFAULT: { label: '常规模式', value: 1 },
  DOUBLE: { label: '双信封模式', value: 2 }
})

// 评审办法
export const reviewMethodModelDict = new Dict({
  DEFAULT: {
    label: '综合评分法',
    value: 1,
    getTemplateFileName: reviewModel =>
      reviewModel === reviewModelDict.DEFAULT.value
        ? '/resources/kpb/常规模式评审办法导入模版-综合评分法.xlsx'
        : '/resources/kpb/双信封模式评审办法导入模版-综合评分法.xlsx'
  },
  PRICE_HIGHEST: {
    label: '最高价法',
    value: 2,
    getTemplateFileName: () =>
      '/resources/kpb/双信封模式评审办法导入模版-最高价法.xlsx'
  },
  PRICE_LOWEST: {
    label: '最低价法',
    value: 3,
    getTemplateFileName: reviewModel =>
      reviewModel === reviewModelDict.DEFAULT.value
        ? '/resources/kpb/常规模式评审办法导入模板-最低价法.xlsx'
        : '/resources/kpb/双信封模式评审办法导入模版-最低价法.xlsx'
  }
})

// 招标评审办法
export const reviewWayTypeDict = (
  reviewModel = reviewModelDict.DEFAULT.value
) => {
  const isDouble = Number(reviewModel) === reviewModelDict.DOUBLE.value
  return new Dict({
    QUALIFICATION: {
      label: '资格评审',
      value: 1,
      alias: 'qualification',
      name: '资格'
    },
    COMPLIANCE: {
      label: isDouble ? '形式评审' : '符合性评审',
      value: 2,
      alias: 'compliance',
      name: '符合性'
    },
    QUOTATION: {
      label: '价格评分',
      value: 3,
      alias: 'quotation',
      name: '价格'
    },
    TECHNICAL: {
      label: '技术评分',
      value: 4,
      alias: 'technical',
      name: '技术'
    },
    BUSINESS: {
      label: '商务评分',
      value: 5,
      alias: 'business',
      name: '商务'
    },
    RESPONSE: {
      label: '响应性评审',
      value: 6,
      alias: 'response',
      name: '响应性'
    },
    TECHNICAL_PASSING: {
      label: '技术评审',
      value: 7,
      alias: 'technical_passing',
      name: '技术'
    },
    BUSINESS_PASSING: {
      label: '商务评审',
      value: 8,
      alias: 'business_passing',
      name: '商务'
    },
    QUOTATION_PASSING: {
      label: '价格评审',
      value: 9,
      alias: 'quotation_passing',
      name: '价格'
    }
  })
}

// 评分汇总模式
export const reviewSummaryModelDict = new Dict({
  GENERAL: { label: '常规汇总', value: 1 },
  WAY_ITEM: { label: '评审点汇总', value: 2 }
})

// 指定的投标文件类型
export const bidFileTypeDict = new Dict({
  BUSINESS: { label: '商务', value: 1 },
  QUOTATION: { label: '报价', value: 2 }
})

// 招标标书目录类型
export const bidFileDirectoryTypeDict = new Dict({
  CUSTOMIZE: { label: '自定义', value: 0 },
  BID_TEXT: { label: '投标正文', value: 1 },
  QUOTE: { label: '投标报价', value: 2 },
  MARK: { label: '开标一览表', value: 3 },
  ITEMIZED: { label: '分项报价表', value: 4 }
})

// 招标评审办法的评审方式
export const bidReviewMethodTypeDict = new Dict({
  PASS_OR_NOT: { label: '是否通过', value: 1 },
  SCORE: { label: '打分', value: 2 }
})

// 招标评审点类型
export const bidReviewPointTypeDict = new Dict({
  SUBJECTIVE: { label: '主观类', value: 1 },
  OBJECTIVE: { label: '客观类', value: 2 }
})

// 招标评分方案
export const bidReviewScoringSchemeDict = new Dict({
  // GRAND_TOTAL: { label: '按分项汇总规则累计分值', value: 1 },
  WITHOUT_HIGHEST_AND_LOWEST: { label: '去掉最高分值和最低分值', value: 2 },
  AVERAGE: { label: '取评分平均值', value: 3 }
})

// 算分类型
export const bidReviewScoringTypeDict = new Dict({
  MANUAL: { label: '手动算分', value: 0 },
  AUTOMATIC: { label: '自动算分', value: 1 }
})

// 评标基准价设置
export const bidReviewBasePriceSettingDict = new Dict({
  HIGHEST: {
    label: '有效报价最高价',
    value: 1,
    formula: setting => [
      `最终得分 = (投标报价/评标基准价) x ${setting.scoreSum ||
        '设置的价格分总分'}`
    ]
  },
  LOWEST: {
    label: '有效报价最低价',
    value: 2,
    formula: setting => [
      `最终得分 = (评标基准价/投标报价) x ${setting.scoreSum ||
        '设置的价格分总分'}`
    ]
  },
  AVERAGE: {
    label: '有效报价平均值*百分比',
    value: 3,
    formula: setting => [
      `报价高于基准价得分 = ${setting.scoreSum} - (投标报价/评标基准价 - 1) x 100 x ${setting.highUnitLessScore}`,
      `报价低于基准价得分 = ${setting.scoreSum} - (1 - 投标报价/评标基准价) x 100 x ${setting.lowUnitLessScore}`
    ],
    needPercentage: true
  },
  WITHOUT_HIGHEST_AND_LOWEST: {
    label: '去掉最高和最低报价的平均值*百分比',
    value: 4,
    formula: setting => [
      `报价高于基准价得分 = ${setting.scoreSum} - (投标报价/评标基准价 - 1) x 100 x ${setting.highUnitLessScore}`,
      `报价低于基准价得分 = ${setting.scoreSum} - (1 - 投标报价/评标基准价) x 100 x ${setting.lowUnitLessScore}`
    ],
    needPercentage: true
  }
})

// 唱标项类型
export const bidMarkTypeDict = new Dict({
  BID_PERSON: { label: '投标单位', value: 1 },
  BID_TOTAL: { label: '投标报价', value: 2 },
  BID_GUARANTEE: { label: '投标保证金', value: 3 },
  CUSTOMIZE: { label: '自定义', value: 4 }
})

// 唱标输入类型
export const bidMarkInputTypeDict = new Dict({
  NUMBER: { label: '数字', value: 1 },
  STRING: { label: '文字', value: 2 }
})

// 唱标单位类型
export const bidMarkUnitTypeDict = new Dict({
  WITHOUT: { label: '无', value: '' },
  YUAN: { label: '元', value: '元' },
  TEN_THOUSAND: { label: '万元', value: '万元' },
  PERCENT: { label: '%', value: '%' }
})

// 专家组建状态字典
export const kpbExpertReadyStatusDict = new Dict({
  INITIAL: { label: '初始化', value: 0 },
  PENDING: { label: '待组建', value: 1 },
  FORMED: { label: '已组建', value: 2 }
})

// 评审专家状态字典
export const kpbExpertStatusDict = new Dict({
  NORMAL: { label: '正常', value: 1 },
  REMOVER: { label: '已移除', value: 2 }
})

// 专家组件类型字典
export const kpbExpertFormationDict = new Dict({
  // 专家抽取
  FROM_EXPERT_LIBRARY: { label: '专家抽取', value: 1 },
  // 项目导入
  FROM_PROJECT: { label: '项目导入', value: 2 },
  // 手动添加
  FROM_MANUAL: { label: '手动添加', value: 3 }
})

// 价格分、技术分、商务分评审过程是否可同时进行
export const isScoreOnceDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 公开开标一览表到供应商
export const isOpenMarkDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})

// 投标单位废标状态
export const bidderWasteStatusDict = new Dict({
  WASTED: { label: '已废标', value: 1 },
  CANCELED: { label: '已取消废标', value: 2 }
})

// 商务文件开标状态
export const bidFileOpenStatsDict = new Dict({
  INIT: { label: '初始化', value: 0 },
  PENDING: { label: '等待开标', value: 1 },
  IN: { label: '开标中', value: 2 }
})
